import { render, staticRenderFns } from "./Lengku.vue?vue&type=template&id=38dc1b7c"
import script from "./Lengku.vue?vue&type=script&lang=js"
export * from "./Lengku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports